export const FORM_PLUGIN_METADATA = {
  DOMAIN: 'autodesk-construction-form',
  TYPE: 'form',
};

export const FORM_FIELD_PLUGIN_METADATA = {
  DOMAIN: 'autodesk-construction-form',
  TYPE: 'formfield',
};

export const FORM_TEMPLATE_PLUGIN_METADATA = {
  DOMAIN: 'autodesk-construction-form',
  TYPE: 'formtemplate',
};

export const FORM_STATUSES = {
  ARCHIVED: 'archived',
  DISCARDED: 'discarded',
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  SUBMITTED: 'submitted',
};

export const FORM_TEMPLATE_STATUSES = {
  ACTIVE: 'active',
  ARCHIVED: 'inactive',
  DELETED: 'deleted',
};

export const FORM_FILTERS_DEFAULT_VALUES = {
  limit: 50,
  sort_by: 'updated_at,report_date',
  sort_order: 'desc,desc',
  statuses: [
    FORM_STATUSES.DRAFT,
    FORM_STATUSES.IN_REVIEW,
    FORM_STATUSES.SUBMITTED,
    FORM_STATUSES.ARCHIVED,
  ],
  include_pg_form_layout: false,
};

export const FORM_TEMPLATES_FILTERS_DEFAULT_VALUES = {
  limit: 250,
  skip: 0,
  status: FORM_TEMPLATE_STATUSES.ACTIVE,
  template_types: [],
  include_components: true,
  include_pg_form_layout: false,
};

export const FORM_TEMPLATE_PERMISSIONS = {
  SUBMIT: 'submit',
  REVIEW: 'review',
  APPROVE: 'approve',
  MANAGE: 'manage',
};

export const FORM_COLLABORATION_MODES = {
  SINGLE: 'SINGLE',
  MULTIPLE_SEQUENCE: 'MULTIPLE_SEQUENCE',
  MULTIPLE_PARALLEL: 'MULTIPLE_PARALLEL',
};

export const FORM_PROPERTY_KEYS = {
  DATE: 'report_date',
  DESCRIPTION: 'title',
  ASSIGNEE: 'assignee_id',
  ASSIGNEE_TYPE: 'assignee_type',
  NOTES: 'description',
};

export const ELEMENT_TYPES = {
  FORM: 'form',
  FIELD: 'field',
  TABLE: 'table',
  SECTION: 'section',
};

export const VALUE_NAMES = {
  SVG_VAL: 'svg_val',
};

export const FORM_ANALYTICS = {
  SEARCH: 'reference.add.search',
  REMOVE: 'reference.remove',
  CREATE: 'field_report.create',
  ADD: 'reference.add',
};

export const FORM_ANALYTICS_CONTRIBUTION_MAP = {
  [FORM_COLLABORATION_MODES.SINGLE]: 'private',
  [FORM_COLLABORATION_MODES.MULTIPLE_SEQUENCE]: 'assigned',
  [FORM_COLLABORATION_MODES.MULTIPLE_PARALLEL]: 'coediting',
};

export const TREE_SCROLL_THRESHOLD = 50;
export const TREE_PAGE_SIZE = 25;
export const FOLDER_TYPE = 'folder';

export const FORM_TEMPLATE_TYPE_TRANSLATION_MAP = {
  'pg.template_type.daily_report': 'DAILY_REPORT_TEMPLATE_TYPE',
  'pg.template_type.quality': 'QUALITY_TEMPLATE_TYPE',
  'pg.template_type.safety': 'SAFETY_TEMPLATE_TYPE',
  'pg.template_type.punchlist': 'PUNCHLIST_TEMPLATE_TYPE',
  'pg.template_type.commissioning': 'COMMISSIONING_TEMPLATE_TYPE',
  'pg.template_type.time_sheet': 'TIME_SHEET_TEMPLATE_TYPE',
  'pg.template_type.other': 'OTHER_TEMPLATE_TYPE',
};

export const FORMS_SWR_CONFIG = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  revalidateOnMount: true,
};

export const ASSIGNEE_TYPES = {
  USER: 'user',
  COMPANY: 'company',
  ROLE: 'role',
};

export const ALLOW_DRAFT_ASSIGNEE_KEY = 'allow_draft_assignee';
export const SINGLE_CONTRIBUTOR_KEY = 'single_contributor';
export const ASSIGNEE_DRAFT_COEDITING_KEY = 'allow_assignee_draft_coediting';
export const DEFAULT_FORM_ASSIGNEE_TO_CREATOR_KEY =
  'default_form_assignee_to_creator';

export const EMPTY_ROOT_FOLDER_ENTITY_ID = 'mock-root-template-entity-id';

export const FEATURE_FLAGS = {
  STATUS_EXPANSION: 'forms_status_expansion_web',
  INHERIT_LOCATION_FROM_ASSET: 'forms_inherit_location_from_asset',
  ENABLE_LIBRARY_COMPONENTS: 'enable_library_components',
  RENAME_FORMS: 'forms_web_enable_form_renaming',
  SCALING_FORMS_M7: 'forms_scaling_m7',
  FORMS_REMOVED_MEMBER: 'forms-web-removed-member',
  FOLDER_API_MIGRATION: 'forms_web_folder_api_migration',
};

export const VIRTUAL_ROW_HEIGHT = 48;

export const VIRTUAL_OVER_SCAN = 3;

export const ENTITIES_MAPPER_KEY = 'id';

export const TABLE_COLUMN_ACCESSOR_KEY = {
  REPORT_DATE: 'report_date',
  REPORT_NUM: 'report_num',
  STATUS: 'status',
  CREATED_BY: 'created_by',
  UPDATED_AT: 'updated_at',
  UPDATED_BY: 'updated_by',
};
